import apiInvite from '@/api/invite'
import { toastFunc } from '@/plugins/toastPlugin'

export default {
  getInviteDataIfNeed: async ({ rootGetters, rootState, state, commit, dispatch }) => {
    const { invite } = rootGetters['marketing/specificQueryParams']
    if (invite) {
      let response
      try {
        response = await apiInvite.getInviteData({ name_slug: invite })
        // TODO: DEV-12834 решить нужно ли выводить скидку и бонусы за приведенного друга
        return response.body
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  chargeBonus: async ({ rootGetters, rootState, state, commit, dispatch }, data) => {
    const { invite } = rootGetters['marketing/specificQueryParams']
    if (
      !invite ||
      JSON.parse(localStorage.getItem('referralBonusWasCharged'))
    ) return
    let response
    const payload = {
      name_slug: invite,
      ...data,
    }
    try {
      response = await apiInvite.chargeBonus(payload)
      const {
        data: {
          bonus_charged: bonusCharged = false,
          success = false,
          message = 'Ошибка применения бонсусов, обратитесь в кол центр',
        },
      } = response
      if (!bonusCharged) return response.body
      localStorage.setItem('referralBonusWasCharged', true)
      if (message) {
        toastFunc({ group: success ? 'success' : 'error', title: message })
      }
      return response.body
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
